export default __webpack_public_path__ + "static/why-ml-3--mobile-34fae4145bd0e550ffb7057faede860b.jpg";